import { render, staticRenderFns } from "./ContactsForm.vue?vue&type=template&id=6d5b7f5d"
import script from "./ContactsForm.vue?vue&type=script&lang=js"
export * from "./ContactsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports